import { Fragment, useState, useEffect } from 'react'

// third party components
import { Dialog, Transition } from '@headlessui/react'

// styles
import styles from './index.module.scss'

import NftCardMenuPage from 'components/Menu/NftCardMenuPage'

export interface NftCardMenuModalProps<T> {
  open: boolean
  onClose: () => void
  isOwn: boolean
  shareArtwork: any
  hideArtwork: any
  unhideArtwork: any
  unSave: any
  cardType: string
  isOnlyShare?: boolean
}

const NftCardMenuModal = <T,>({
  open,
  onClose,
  isOwn,
  shareArtwork,
  hideArtwork,
  unhideArtwork,
  unSave,
  cardType,
  isOnlyShare = true,
}: NftCardMenuModalProps<T>) => {
  const closeModal = () => {
    onClose()
  }

  const [show, setShow] = useState(false)

  useEffect(() => {
    if (open) {
      setTimeout(() => {
        setShow(true)
      }, 100)
    }
  }, [open])

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className={styles.container} onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className={styles.bgView} />
        </Transition.Child>
        <div className="fixed inset-0" onClick={() => closeModal()}>
          <div className={`${styles.modalView} ${show ? styles.show : styles.hide}`}>
            <div className="w-full h-full">
              <NftCardMenuPage
                shareArtwork={shareArtwork}
                hideArtwork={hideArtwork}
                isOwn={isOwn}
                unhideArtwork={unhideArtwork}
                unSave={unSave}
                cardType={cardType}
                isOnlyShare={isOnlyShare}
              />
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

export default NftCardMenuModal
